'use strict';

var RecapServiceDtdPaxGapAggregationFactory = function RecapServiceDtdPaxGapAggregationFactory(DataAggregationFactory) {
  function RecapServiceDtdPaxGapAggregation() {
    DataAggregationFactory.call(this, 'rom-analysis-flattened-services-mode', 'recap-service-dtd-pax-gap');
  }
  RecapServiceDtdPaxGapAggregation.prototype = Object.create(DataAggregationFactory.prototype);
  RecapServiceDtdPaxGapAggregation.constructor = RecapServiceDtdPaxGapAggregation;
  RecapServiceDtdPaxGapAggregation.prototype.canAggregate = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType === targetType;
  };
  RecapServiceDtdPaxGapAggregation.prototype.aggregate = function (data, metricsKeys) {
    var aggregatedRecapPaxGap = [],
      map = [];
    var self = this;
    for (var i = 0; i < data.length; i++) {
      var record = data[i];
      var rangeName = 'range' + record.romTimeBucket;
      var service = record.service;
      var mapServiceIndex = map.indexOf(service);
      var recapPaxGap = {};
      if (mapServiceIndex === -1) {
        recapPaxGap[rangeName] = self.getMetricValue(record.recapPaxGap, metricsKeys, true);
        recapPaxGap.potentialRevenue = self.getMetricValue(record.potentialRevenue, metricsKeys, true);
        recapPaxGap.service = service;
        aggregatedRecapPaxGap.push(recapPaxGap);
        map.push(service);
      } else if (!aggregatedRecapPaxGap[mapServiceIndex][rangeName]) {
        aggregatedRecapPaxGap[mapServiceIndex][rangeName] = self.getMetricValue(record.recapPaxGap, metricsKeys, true);
        aggregatedRecapPaxGap[mapServiceIndex].potentialRevenue += self.getMetricValue(record.potentialRevenue, metricsKeys, true);
      } else {
        aggregatedRecapPaxGap[mapServiceIndex][rangeName] += self.getMetricValue(record.recapPaxGap, metricsKeys, true);
        aggregatedRecapPaxGap[mapServiceIndex].potentialRevenue += self.getMetricValue(record.potentialRevenue, metricsKeys, true);
      }
    }
    return self.sortBy(aggregatedRecapPaxGap, 'potentialRevenue', 'DESC');
  };
  return RecapServiceDtdPaxGapAggregation;
};
RecapServiceDtdPaxGapAggregationFactory.$inject = ['AbstractROMServiceAggregationFactory'];
module.exports = RecapServiceDtdPaxGapAggregationFactory;